"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f382 = void 0;
exports.f382 = {
    "žesteri": [
        124
    ],
    "žestomimičen": [
        1063
    ],
    "žemaitis": [
        6822
    ],
    "žemaitiu": [
        6822
    ],
    "žemaitiškai": [
        6822
    ],
    "žemaičiai": [
        6822
    ],
    "žemaičių": [
        6822
    ]
};
